<template>
  <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
  <meta name="apple-mobile-web-app-capable" content="yes" />
  <body >
  <div class="min-h-screen bg-gray-100 text-gray-900 flex justify-center dlbox">
    <div class="max-w-screen-xl m-0 sm:m-20 bg-white shadow sm:rounded-lg flex justify-center flex-1">
      <div class="lg:w-1/2 xl:w-5/12 p-6">
<!--        <svg-icon iconClass="element-plus-logo" width="100" style="height:50px"></svg-icon>-->
        <img v-if="!isWi5" :src="jh_Image"  width="100"/>

        <div class="mt-12 flex flex-col items-center">

          <h1 class="text-2xl xl:text-3xl font-extrabold">欢迎回来</h1>

          <div class="w-full flex-1 mt-8">
            <!-- 三方登录模块         -->
            <!--<div class="flex flex-col items-center">
              <button class="w-full max-w-xs font-bold shadow-sm rounded-lg py-3 bg-indigo-100 text-gray-800 flex items-center justify-center ease-in-out focus:outline-none hover:shadow focus:shadow-sm focus:shadow-outline">
                <div class="weixin"></div>
                <span class="ml-4">使用微信登录</span>
              </button>
              <button class="w-full max-w-xs font-bold shadow-sm rounded-lg py-3 bg-indigo-100 text-gray-800 flex items-center justify-center ease-in-out focus:outline-none hover:shadow focus:shadow-sm focus:shadow-outline mt-5">
                <div class="weibo"></div>
                <span class="ml-4">使用微博登录</span>
              </button>
            </div>-->

            <div class="my-12 border-b text-center">
              <div class="leading-none px-2 inline-block text-sm text-gray-600 tracking-wide font-medium bg-white transform translate-y-1/2">时光知味,岁月沉香。</div>
            </div>

            <div class="mx-auto max-w-xs">
              <input class="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"  v-model="username" @change="usernameChange" placeholder="账号">
              <input class="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5" v-model="password" type="password" placeholder="密码">
              <input class="w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5" v-model="verifyCode" type="text" placeholder="验证码" @keyup.enter="submitForm">
              <span class="show-img">
                <img :src="verifyUrl" alt="获取验证码" @click="verifyCodeClick">
              </span>
              <label class="remember-password mt-4 flex items-center cursor-pointer select-none">
                <input type="checkbox" v-model="rememberPassword" class="remember-checkbox">
                <span class="ml-2 text-sm text-gray-600">记住密码</span>
              </label>
              <button class="mt-5 tracking-wide font-semibold bg-indigo-500 text-gray-100 w-full py-4 rounded-lg hover:bg-indigo-700 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none" @click="submitForm">
                <span class="ml-3">登 录</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-1 bg-indigo-100 text-center hidden lg:flex">
        <div class="m-12 xl:m-16 w-full bg-contain bg-center bg-no-repeat"  :style="{'background-image': `url(${require('@/icons/svg/dlbox.png')})`}"></div>
      </div>
    </div>
  </div>

  <div class="bg-gray-100" style="min-height:3vh">
    <div class="ivu-global-footer-copyright">Copyright © {{currentYear-1}} - {{currentYear}}   <a href="https://beian.miit.gov.cn">{{icpNumber}}</a></div>
  </div>
</body>

</template>



<script>
import callApi from '@/api/api';
import {ElMessage} from "element-plus";
import { loginUserStore } from '@/stores/loginUserStore';
import refreshToken from "@/api/refreshToken";

import jh_Image from"@/assets/jh/img.png"
import { isWi5Domain } from "@/utils/domain";



let BASE_URL = process.env.VUE_APP_API_BASE_URL
const REMEMBER_PASSWORD_KEY = "login_remember_password"

export default {
  data: function () {
    return {
      verifyUrl: BASE_URL+"/infoaccountadmin/userLogin/get/verify?username=",
      username: null,
      password: null,
      verifyCode: null,
      rememberPassword: false,
      currentYear: new Date().getFullYear(),
      jh_Image,
      isWi5: isWi5Domain(),
      icpNumber: isWi5Domain() ? '浙ICP备2026064097号-1' : '浙ICP备17024771号-3'
    }
  },
  setup() {
    function setLoginUser(data){
      loginUserStore().setLoginUser(data);
    }
    /*是否已经登录*/
    async function haslogin() {
      var Authtoken = (localStorage.getItem("loginUserStore") == null) ? "" : JSON.parse(localStorage.getItem("loginUserStore")).auth_token
      if(Authtoken!==undefined){
        var retMsg = await refreshToken()
        if(retMsg === "success"){
          // 跳转 首页
          let redirect = this.getQueryString("redirect")
          if(redirect == null){
            // 跳转 首页
            this.$router.push('/index');
          }else{
            this.$router.push(redirect);
          }
        }
      }

    }
    return {
      setLoginUser,
      haslogin
    }
  },
  mounted() {
    // 初始化数据
    this.loadRememberPassword();
    this.haslogin();
  },
  activated() {
    this.loadRememberPassword();
    this.haslogin();
  },
  methods: {
    // 用户刷新
    usernameChange(){
      // 刷新验证码
      this.verifyCodeClick();
    },
    // 读取本地记住的账号密码
    loadRememberPassword() {
      try {
        const saved = localStorage.getItem(REMEMBER_PASSWORD_KEY);
        if (!saved) {
          return;
        }
        const data = JSON.parse(saved);
        if (data && data.username) {
          this.username = data.username;
          this.password = data.password ? decodeURIComponent(atob(data.password)) : null;
          this.rememberPassword = true;
          this.verifyCodeClick();
        }
      } catch (e) {
        localStorage.removeItem(REMEMBER_PASSWORD_KEY);
      }
    },
    // 保存或清除记住的账号密码
    saveRememberPassword() {
      if (this.rememberPassword) {
        localStorage.setItem(REMEMBER_PASSWORD_KEY, JSON.stringify({
          username: this.username,
          password: btoa(encodeURIComponent(this.password))
        }));
      } else {
        localStorage.removeItem(REMEMBER_PASSWORD_KEY);
      }
    },
    // 提交表单
    async submitForm() {
      // 校验参数
      if(this.$data.username==null){
        ElMessage({
          message: "账号不能为空",
          type: 'warning',
        })
        return ;
      }
      if(this.$data.password==null){
        ElMessage({
          message: "密码不能为空",
          type: 'warning',
        })
        return ;
      }
      // 发起请求
      // 使用callApi函数调用接口
      let requestData = {
        "username":this.$data.username,
        "password":this.$data.password,
        "verifyCode":this.$data.verifyCode
      }
      const data = await callApi('/infoaccountadmin/userLogin/loginByPasswordForToken', 'post' , requestData);
      // 处理登录逻辑
      if(data){
        //console.log(data.data)
        this.saveRememberPassword();
        this.setLoginUser(data.data);
        // 跳转 首页
        let redirect = this.getQueryString("redirect")
        if(redirect == null){
          // 跳转 首页
          this.$router.push('/index');
        }else{
          this.$router.push(redirect);
        }

      }

    },
    // 随机数
    nextTick(){
      let arr = [];
      for (let i = 0; i < 18; i++) {
        let s = Math.round(Math.random() * 1000) / 10;
        arr.push(s);
        return s;
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 验证码点击更新
    verifyCodeClick(){
      this.$data.verifyUrl=BASE_URL+"/infoaccountadmin/userLogin/get/verify?username="+this.$data.username+"&str="+this.nextTick()
    }
  }
}

/*禁止ios缩放，双击和双指*/
window.onload = function() {
  document.addEventListener("touchstart", function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  var lastTouchEnd = 0;
  document.addEventListener(
      "touchend",
      function(event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
  );
  document.addEventListener("gesturestart", function(event) {
    event.preventDefault();
  });
};
</script>

<style scoped>
@import "@/assets/login/css/tailwind.min.css";

.dlbox .weixin, .dlbox .weibo {
  display: inline-block;
  width: 32px;
  height: 32px;
  background-size: cover;
}
.bg-indigo-100 {
  background-color: #ebf4ff;
}
.border-gray-200 {
   border-color: #edf2f7;
}
.bg-gray-100 {
    background-color: #f7fafc;
}
.bg-indigo-500 {
     background-color: #667eea;
}
.min-h-screen{
  min-height:97vh
}
.ivu-global-footer-copyright{
  font-size: 15px;
  color: gray;
  text-align: center;
}
.remember-password {
  width: 100%;
}
.remember-checkbox {
  width: 14px;
  height: 14px;
  cursor: pointer;
  accent-color: #667eea;
}

</style>
